import { TripDriverInfo } from '../trips/trips.model';

export type VALIDATIONS_HELPER_TYPE =
  | 'DATE_WARNING'
  | 'CUSTOMER_ORDER_WARNING'
  | 'DRIVER_DOCUMENT_EXPIRATION'
  | 'EQUIPMENT_DOCUMENT_EXPIRATION'
  | 'DRIVER_TIME_OFF'
  | 'EQUIPMENT_OUT_OF_SERVICE';

export type VALIDATIONS_HELPER_WARNING =
  | 'FUTURE_DATE'
  | 'OLDER_DATE'
  | 'ALREADY_ASSOCIATED'
  | 'EXPIRING_SOON'
  | 'EXPIRED'
  | 'TIME_OFF_CONFLICT'
  | 'OUT_OF_SERVICE';

export interface Validation {
  type: VALIDATIONS_HELPER_TYPE;
  warningType: VALIDATIONS_HELPER_WARNING;
  message: string;
  extraInfo?: any;
}

export interface ValidationsResponse {
  message: string;
  data: Validation[];
}

export enum FLOWS {
  ORDERS = 'ORDERS',
  TRIPS = 'TRIPS',
  LOAD = 'LOAD'
}

export type FLOWS_TYPE = keyof typeof FLOWS;

export interface ValidationPayload {
  flow: FLOWS_TYPE;
  order_id?: string;
  customer_order_number?: string;
  dispatch_type?: string;
  trips?: ValidationTrips[];
}

export interface ValidationTrips {
  id?: string;
  drivers?: TripDriverInfo[];
  truck_id?: string | null;
  trailer_id?: string | null;
  start_date?: string;
  stop_date?: string;
  start_from_time?: string;
  stop_from_time?: string;
}
